import React, { useEffect, useState } from 'react';
import FlippexLoader from '../components/ui/FlippexLoader';
import { api } from '../context/AuthContext';
import { ActivityFeed } from '../components/investor/InvestmentCard';

const FILTERS = [
  { key: 'all', label: 'All' },
  { key: 'investments', label: 'Investments' },
  { key: 'returns', label: 'Returns' },
  { key: 'updates', label: 'Project updates' },
];

export default function ActivityPage() {
  const [events, setEvents] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/portfolio/v2/activity?kind=${filter}&limit=60`)
      .then((res) => setEvents(res.data.events || []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [filter]);

  return (
    <div className="container mx-auto px-5 md:px-8 max-w-[860px] py-8 md:py-12" data-testid="investor-activity-page">
        <h1 className="text-2xl md:text-3xl font-heading">Activity</h1>
        <p className="text-sm text-foreground-muted mt-1.5">Everything that happened across your investments.</p>

        <div className="mt-6 flex items-center gap-1 rounded-xl bg-slate-100/80 p-1 overflow-x-auto">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              onClick={() => setFilter(f.key)}
              className={`px-3 py-1.5 text-xs rounded-lg whitespace-nowrap transition-colors ${
                filter === f.key ? 'bg-white shadow-sm font-medium' : 'text-foreground-muted'
              }`}
              data-testid={`activity-filter-${f.key}`}
            >
              {f.label}
            </button>
          ))}
        </div>

        <section className="mt-5 bg-white rounded-2xl border border-black/[0.05]">
          {loading ? (
            <div className="py-16 flex justify-center">
              <FlippexLoader size={48} animate={false} />
            </div>
          ) : (
            <ActivityFeed
              events={events}
              emptyMessage="Nothing here yet. Investments, returns and project updates will appear as they happen."
            />
          )}
        </section>
    </div>
  );
}
